











import PageSection from '@/uikit/components/AppDefaultLayout/components/sections/PageSection.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import { layoutUtils } from '@/uikit/components/AppDefaultLayout/utils/utils';

export default {
  components: { PageSection },
  props: {
    layoutSpecialContentConfig: {
      type: Object as () => LayoutConfig['content'],
    },
    layoutDataSet: {
      type: Object as () => LayoutDataSet,
    },
  },
  data() {
    return {
      utils: layoutUtils,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/specialContents/startPage/StartPage.vue